'use client';
import { create } from 'zustand';

export type CheckoutStep =
  | 'idle' |'payment_instructions' |'awaiting_hash' |'verifying' |'success' |'error';

export interface CheckoutState {
  isOpen: boolean;
  step: CheckoutStep;
  txHash: string;
  errorMessage: string;
  btcRate: number;
  openModal: () => void;
  closeModal: () => void;
  setStep: (step: CheckoutStep) => void;
  setTxHash: (hash: string) => void;
  setErrorMessage: (msg: string) => void;
  reset: () => void;
}

// BACKEND INTEGRATION POINT: Replace btcRate with live fetch from a BTC price API
const MOCK_BTC_RATE = 102_450; // USD per BTC — mock value
const USD_PRICE = 100;

export const useCheckoutStore = create<CheckoutState>((set) => ({
  isOpen: false,
  step: 'idle',
  txHash: '',
  errorMessage: '',
  btcRate: MOCK_BTC_RATE,
  openModal: () => set({ isOpen: true, step: 'payment_instructions' }),
  closeModal: () => set({ isOpen: false }),
  setStep: (step) => set({ step }),
  setTxHash: (txHash) => set({ txHash }),
  setErrorMessage: (errorMessage) => set({ errorMessage }),
  reset: () => set({
    isOpen: false,
    step: 'idle',
    txHash: '',
    errorMessage: '',
  }),
}));

export const BTC_AMOUNT = (USD_PRICE / MOCK_BTC_RATE).toFixed(8);
export const USD_AMOUNT = USD_PRICE;